<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col cols="6" lg="4">
          <v-select
            v-model="filter.releaseTypeId"
            :label="$t('label.releaseType')"
            :items="releaseTypes" item-text="name"
            item-value="id"
            outlined
            dense
            @change="filterReleases">
          </v-select>
        </v-col>
        <v-col cols="6" lg="4">
          <v-select
            v-model="filter.releaseStatusId"
            :label="$t('label.status')"
            :items="releaseStatus" item-text="name"
            item-value="id"
            outlined
            dense
            @change="filterReleases">
          </v-select>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="releasesFiltered"
        :loading="isLoading"
        :options="options"
      >
        <template v-slot:[`item.releaseTypeId`]="{ item }">
          {{ getReleaseTypeName(item.releaseTypeId) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip small color="success" v-if="isReleaseNew(item.status)">{{ $t('label.new') }}</v-chip>
          <v-chip small color="default" v-if="isReleaseConfirmed(item.status)">{{ $t('label.confirmed') }}</v-chip>
        </template>
        <template v-slot:[`item.options`]="{ item }">
          <v-btn class="btn-action" icon :title="$t('label.details')" small depressed @click.stop="selectRelease(item, 'detail')">
            <v-icon color="primary">mdi-file-document</v-icon>
          </v-btn>
          <!-- <v-btn class="btn-action" icon :title="$t('label.sendComments')" small depressed @click.stop="selectRelease(item, 'comment')">
            <v-icon color="primary">mdi-message</v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { loading, showMessage } from '../../../mixins'
import { releaseStatus, releaseTypes } from '../../../core/EDI/enums'

export default {
  name: 'ReleasesList',
  mixins: [loading, showMessage],
  data: () => ({
    releases: [],
    releasesFiltered: [],
    releaseSelected: {},
    options: {
      sortBy: ['id'],
      sortDesc: [true],
      itemsPerPage: 10
    },
    filter: {
      releaseTypeId: 0,
      releaseStatusId: 0
    }
  }),
  computed: {
    headers () {
      let headers = [
        { text: this.$t('label.releaseOrPO'), value: 'releaseOrOrder', align: 'center', sortable: true, filterable: true }
      ]

      if (this.filter.releaseTypeId !== releaseTypes.FORECAST) {
        headers = [
          ...headers,
          { text: this.$t('label.partNumber'), value: 'partNumber', align: 'center', sortable: true, filterable: true }
        ]
      }

      headers = [
        ...headers,
        { text: this.$t('label.type'), value: 'releaseTypeId', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.date'), value: 'date', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.status'), value: 'status', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    },
    releaseStatus () {
      const status = [
        { id: 0, name: this.$t('label.all') },
        { id: releaseStatus.NEW, name: this.$t('label.new') },
        { id: releaseStatus.CONFIRMED, name: this.$t('label.confirmed') }
      ]
      return status
    },
    releaseTypes () {
      const types = [
        { id: 0, name: this.$t('label.all') },
        { id: releaseTypes.FIRM, name: this.$t('label.firm') },
        { id: releaseTypes.FORECAST, name: this.$t('label.forecast') }
      ]
      return types
    }
  },
  methods: {
    getReleases () {
      this.changeLoadingStatus(true)
      this.$proxy.get('api/edi/releases')
        .then((r) => {
          this.releases = r.data
          this.releases = this.releases.map((x) => {
            // x.date = `${x.generationDate}${x.generationTime}`
            if (x.releaseTypeId === releaseTypes.FORECAST) {
              x.partNumber = ''
            }
            return x
          })

          this.releasesFiltered = [...this.releases]
          if (sessionStorage.getItem('vendorPortalExtReleasesFilter')) {
            const f = sessionStorage.getItem('vendorPortalExtReleasesFilter')
            this.filter = JSON.parse(f)
            this.filterReleases()
          }
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    selectRelease (item, action) {
      sessionStorage.setItem('vendorPortalExtReleasesFilter', JSON.stringify(this.filter))
      this.$emit('itemSelected', item, action)
    },
    filterReleases () {
      this.releasesFiltered = this.releases
        .filter(r => (this.filter.releaseTypeId === 0 || this.filter.releaseTypeId === r.releaseTypeId) &&
          (this.filter.releaseStatusId === 0 || this.filter.releaseStatusId === r.status))
    },
    isReleaseNew (status) {
      return status === releaseStatus.NEW
    },
    isReleaseConfirmed (status) {
      return status === releaseStatus.CONFIRMED
    },
    getReleaseTypeName (releaseTypeId) {
      switch (releaseTypeId) {
        case releaseTypes.FIRM:
          return this.$t('label.firm')
        case releaseTypes.FORECAST:
          return this.$t('label.forecast')
        default: return ''
      }
    }
  },
  mounted () {
    this.getReleases()
  }
}
</script>

<style>

</style>
